import { schema } from 'normalizr';

export const appSchema = new schema.Entity('app', {}, { idAttribute: '_id' });
